'use client';

// RUBAN — bande défilante qui sépare le hero du voyage du téléphone.
//
// Rôle : donner du mouvement dès le premier défilement et énoncer, en un coup d'œil, le
// vocabulaire du produit. Le contenu est dupliqué et translaté de -50 % → boucle sans couture.
// Le survol met en pause, pour laisser lire.

import { useT } from '@/hooks/useT';

const WORDS = Array.from({ length: 10 }, (_, i) => `manifesto.ribbon.${i}`);

export function Ribbon() {
  const { t } = useT('landing');

  return (
    <div className="rmbr-marquee-host relative overflow-hidden border-y border-border bg-surface/50 py-4">
      {/* Fondus latéraux : le ruban semble surgir du fond plutôt que d'être coupé net. */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-background to-transparent"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-background to-transparent"
      />

      <div
        className="rmbr-marquee flex w-max items-center gap-8"
        style={{ ['--rmbr-marquee-duration' as string]: '46s' }}
      >
        {[0, 1].map((pass) => (
          <div
            key={pass}
            className="flex items-center gap-8"
            aria-hidden={pass === 1}
          >
            {WORDS.map((key) => (
              <span
                key={key}
                className="flex items-center gap-8 whitespace-nowrap"
              >
                <span
                  className="text-text-secondary"
                  style={{
                    fontFamily: 'var(--font-serif)',
                    fontSize: 17,
                    fontWeight: 500,
                    fontStyle: 'italic',
                  }}
                >
                  {t(key)}
                </span>
                <span
                  aria-hidden
                  className="size-1 shrink-0 rounded-full bg-brand"
                />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
